// extracted by mini-css-extract-plugin
var _1 = "tjs-story-panel__is-mounted";
var _2 = "tjs-story-panel__is-mounted";
var _3 = "tjs-story-panel__left";
var _4 = "tjs-story-panel__right";
var _5 = "tjs-story-panel__story-container";
var _6 = "tjs-story-panel__story-container";
export { _1 as "is-mounted", _2 as "isMounted", _3 as "left", _4 as "right", _5 as "story-container", _6 as "storyContainer" }
export default { "is-mounted": _1, "isMounted": _2, "left": _3, "right": _4, "story-container": _5, "storyContainer": _6 }
